// Lib
import { compareDesc, compareAsc } from 'date-fns';

export const SORTING_FIELD_MAP = {
  date: 'planned_date_first_use',
  name: 'product_description',
  'stock number': 'product_id',
  orders: 'orders_count',
  rating: 'family_rate.rating',
};

const compareStrings = (order, a, b) => {
  if (a > b) {
    return order === 'desc' ? -1 : 1;
  }
  if (b > a) {
    return order === 'desc' ? 1 : -1;
  }
  return 0;
};

export const createNameComparator =
  (order, productsObj, orderBy) => (productIdA, productIdB) => {
    const productA = productsObj?.[productIdA];
    const productB = productsObj?.[productIdB];
    const field = SORTING_FIELD_MAP?.[orderBy];

    const a = productA?.[field]?.toLowerCase();
    const b = productB?.[field]?.toLowerCase();

    return compareStrings(order, a, b);
  };

const getDateCompareResult = (order, a, b) => {
  const compareFunc = order === 'desc' ? compareDesc : compareAsc;

  if (a & b) {
    return compareFunc(a, b);
  }
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  return -1;
};

const compareByProductName = (order, productA, productB) => {
  const nameA = productA?.product_description?.toLowerCase();
  const nameB = productB?.product_description?.toLowerCase();

  return compareStrings(order, nameA, nameB);
};

export const createDateComparator =
  (order, productsObj, orderBy) => (productIdA, productIdB) => {
    const productA = productsObj?.[productIdA];
    const productB = productsObj?.[productIdB];
    const field = SORTING_FIELD_MAP?.[orderBy];

    let a = productA?.[field];
    let b = productB?.[field];
    a = a ? new Date(a) : a;
    b = b ? new Date(b) : b;

    const compareResult = getDateCompareResult(order, a, b);

    if (compareResult === 0) {
      return compareByProductName(order, productA, productB);
    }

    return compareResult;
  };

export const createNumberComparator =
  (order, productsObj, orderBy) => (productIdA, productIdB) => {
    const productA = productsObj?.[productIdA];
    const productB = productsObj?.[productIdB];
    const keyString = SORTING_FIELD_MAP?.[orderBy];
    const arrKeys = keyString?.split('.');

    let a = productA?.[arrKeys?.[0]];
    let b = productB?.[arrKeys?.[0]];
    if (arrKeys?.length > 1) {
      a = a?.[arrKeys?.[1]];
      b = b?.[arrKeys?.[1]];
    }

    return order === 'desc' ? a - b : b - a;
  };

export const createOrdersComparator =
  (order, sortedByOrders) => (firstId, secondId) => {
    const firstValue = sortedByOrders[firstId] || 0;
    const secondValue = sortedByOrders[secondId] || 0;

    return order === 'desc'
      ? secondValue - firstValue
      : firstValue - secondValue;
  };
